import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonEventRegistrationCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import FormEventRegistration from 'system/components/event-registration/form';
import { EventRegistrationForDE } from 'shell/models/event-registration';
import {
  transformEventRegistration,
  transformEventRegistrationResponse,
} from '../utils/transformer-event-registration';
import { noop } from 'shell/utils/noop';

const EventRegistrationDetailPage = (): React.ReactElement => {
  const paramsData = useParams();

  const navigate = useNavigate();

  const [eventRegistration] = useHttpFetch<
    HttpResponse<EventRegistrationForDE>,
    transformEventRegistrationResponse
  >(
    `${__OPERATION__EVENT__ADMIN__}/iscrizioneEvento?codiceSottoscrittore=${Number.parseInt(
      paramsData.codiceSottoscrittore
    )}&codiceTipoDestinazione=${Number.parseInt(
      paramsData.codiceTipoDestinazione
    )}&codiceTipoEvento=${paramsData.codiceTipoEvento}&progressivo=${paramsData.progressivo}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformEventRegistration,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonEventRegistrationCrumbs, { name: 'Dettaglio Iscrizione Evento' }]}
      />
      <FormEventRegistration
        title="Dettaglio Iscrizione Evento"
        onOk={noop}
        initialValues={eventRegistration?.data as transformEventRegistrationResponse}
        disabled
        isDetail
        onCancel={() => {
          navigate('/sistema/eventmanager/iscrizione-evento');
        }}
      />
    </Fragment>
  );
};

EventRegistrationDetailPage.displayName = 'Event Registration Detail component';

export default EventRegistrationDetailPage;
